import React from "react";
import { Sheet } from "@mui/joy";
import LoginForm from "components/admin/LoginForm";

const AdminLogin: React.FC = () => {
  return (
    <Sheet
      sx={{
        minHeight: "100vh",
        backgroundColor: "#f4f4f4",
        display: "flex",
        justifyContent: "center",
        alignItems: "start",
        pt: 4,
        px: 2,
        boxShadow: "none",
        border: "none",
      }}
    >
      <LoginForm />
    </Sheet>
  );
};

export default AdminLogin;
